module.exports = __webpack_public_path__ + "static/vanbex-0cd5d79e1ebf527984ec3b393c0dc8ca.png";